export const LENDING_TERMS = Object.freeze([
    { value: '4', labelKey: '§calc.step1.lending_options.4' },
    { value: '5', labelKey: '§calc.step1.lending_options.5' },
    { value: '6', labelKey: '§calc.step1.lending_options.6' },
    { value: '7', labelKey: '§calc.step1.lending_options.7' },
])

export const LENDING_DROPDOWN_OPTIONS = Object.freeze(
    LENDING_TERMS.map((t) => ({ value: t.value, label: t.labelKey })),
)
